/*
 * Copyright (c) 2025 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { InjectionToken } from '@angular/core';

export interface CellData<T> {
  value: T;
  config?: Record<string, any>;
}

export const CELL_DATA = new InjectionToken('CELL_DATA');
